import { render, staticRenderFns } from "./LocationItem.vue?vue&type=template&id=fc053a3c"
import script from "./LocationItem.vue?vue&type=script&lang=js"
export * from "./LocationItem.vue?vue&type=script&lang=js"
import style0 from "./LocationItem.vue?vue&type=style&index=0&id=fc053a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports